export enum HELP_MENU_ID {
  ROOT = 'help',
  FAQS = 'faqs',
  CHAT_TO_US = 'chat-to-us',
  ABOUT = 'about',
  RESPONSIBLE_GAMBLING = 'responsible-gambling',
  RESPONSIBLE_GAMBLING_NON_EXPANDABLE = 'responsible-gambling-non-expandable',
}

export enum HELP_MENU_SUB_TAB_ID {
  RULES = 'rules',
  T_AND_C = 't&cs',
  COMPLAINTS = 'complaints',
  PRIVACY = 'privacy',
  CONTROL = 'control',
  PROBLEM = 'problem',
  SUPPORT = 'support',
  UNDERAGE = 'underage',
  BLOCKING = 'blocking',
}

export enum HELP_MENU_CONTENT_TYPE {
  PARAGRAPH = 'paragraph',
  BULLET = 'bullet',
  LINK = 'link',
  BULLET_LINK = 'bullet-link',
}
